export function getToken() {
  return localStorage.getItem('userToken');
}